<template>
    <div>
        <div v-loading="loading" class="common-table common-scroll">
            <strong>国内：</strong>
            <el-table
                    ref="inlandsTable"
                    :data="networkList.inlands"
                    row-key="id"
                    highlight-current-row
                    @current-change="handleCurrentChange('inlandRow',$event)">
                <el-table-column label="状态" align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status" style="color: #409EFF;">启用</span>
                        <span v-else>未启用</span>
                    </template>
                </el-table-column>
                <el-table-column label="域名" align="center" width="250">
                    <template slot-scope="scope">
                        <p>res:{{scope.row.resDomain}}</p>
                        <p>http:{{scope.row.httpDomain}}</p>
                        <p>sck:{{scope.row.sckDomain}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="resIp" align="center" width="250">
                    <template slot-scope="scope">
                        <input-set-value
                                size="small"
                                :defaultValue="scope.row.resIp"
                                @my-submit="setConfig('inlands','resIp',scope.row.id,$event)"/>
                    </template>
                </el-table-column>
                <el-table-column label="httpIp" align="center" width="250">
                    <template slot-scope="scope">
                        <input-set-value
                                size="small"
                                :defaultValue="scope.row.httpIp"
                                @my-submit="setConfig('inlands','httpIp',scope.row.id,$event)"/>
                    </template>
                </el-table-column>
                <el-table-column label="sckIp" align="center" width="250">
                    <template slot-scope="scope">
                        <input-set-value
                                size="small"
                                :defaultValue="scope.row.sckIp"
                                @my-submit="setConfig('inlands','sckIp',scope.row.id,$event)"/>
                    </template>
                </el-table-column>
                <el-table-column label="防护策略" align="center">
                    <template slot-scope="scope">{{scope.row.connectWay?'太极盾':'自建'}}</template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark"/>
            </el-table>

            <strong style="display:block;padding-top: 20px">国外：</strong>
            <el-table
                    ref="abroadsTable"
                    :data="networkList.abroads"
                    row-key="id"
                    highlight-current-row
                    @current-change="handleCurrentChange('abroadRow',$event)">
                <el-table-column label="状态" align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status" style="color: #409EFF;">启用</span>
                        <span v-else>未启用</span>
                    </template>
                </el-table-column>
                <el-table-column label="域名" align="center" width="250">
                    <template slot-scope="scope">
                        <p>res:{{scope.row.resDomain}}</p>
                        <p>http:{{scope.row.httpDomain}}</p>
                        <p>sck:{{scope.row.sckDomain}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="resIp" align="center" width="250">
                    <template slot-scope="scope">
                        <input-set-value
                                size="small"
                                :defaultValue="scope.row.resIp"
                                @my-submit="setConfig('abroads','resIp',scope.row.id,$event)"/>
                    </template>
                </el-table-column>
                <el-table-column label="httpIp" align="center" width="250">
                    <template slot-scope="scope">
                        <input-set-value
                                size="small"
                                :defaultValue="scope.row.httpIp"
                                @my-submit="setConfig('abroads','httpIp',scope.row.id,$event)"/>
                    </template>
                </el-table-column>
                <el-table-column label="sckIp" align="center" width="250">
                    <template slot-scope="scope">
                        <input-set-value
                                size="small"
                                :defaultValue="scope.row.sckIp"
                                @my-submit="setConfig('abroads','sckIp',scope.row.id,$event)"/>
                    </template>
                </el-table-column>
                <el-table-column label="防护策略" align="center">
                    <template slot-scope="scope">{{scope.row.connectWay?'太极盾':'自建'}}</template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark"/>
            </el-table>
        </div>
        <div class="footer">
            <el-button type="primary" @click="saveFunc">保存</el-button>
        </div>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <i class="common-popup-close el-icon-close" @click="show= false"></i>
                <h3>推送</h3>
                <table class="common-popup-table">
                    <tr>
                        <td>渠道：</td>
                        <td>
                            <el-select size="medium" v-model="channel">
                                <el-option
                                        v-for="item of channelOptions"
                                        :key="item.label"
                                        :label="item.label"
                                        :value="item.value"/>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td>客户端：</td>
                        <td>
                            <el-select size="medium" v-model="machineType">
                                <el-option
                                        v-for="item of machineTypeOptions"
                                        :key="item.label"
                                        :label="item.label"
                                        :value="item.value"/>
                            </el-select>
                        </td>
                    </tr>
                </table>
                <footer>
                    <el-button type="primary" size="small" @click="pushFunc">推送</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import inputSetValue from 'components/inputSetValue'

    export default {
        components: {
            inputSetValue
        },
        data() {
            return {
                loading: false,
                show: false,// 推送弹窗
                inlandRow: '',// 选中要启用 国内
                abroadRow: '',// 选中要启用 国外
                channel: 0,// 推送渠道
                machineType: 0,// 推送客服端
                channelOptions: [
                    {label: '全部', value: 0},
                    {label: 'IM', value: 1},
                    {label: '极光', value: 2}
                ],
                machineTypeOptions: [
                    {label: '全部', value: 0},
                    {label: 'android', value: 1},
                    {label: 'ios', value: 2}
                ]
            }
        },
        computed: {
            ...mapState('network', ['networkList'])
        },
        mounted() {
            this.getList()
        },
        methods: {
            ...mapMutations('network', ['setStateNetworkList']),
            ...mapActions('network', ['getNetworkList', 'switchNetwork', 'pushInfo']),
            getList() {
                this.loading = true;
                this.getNetworkList().then(() => {
                    this.$refs.inlandsTable.setCurrentRow(this.networkList.inlands.filter(item => {
                        return item.status
                    })[0]);
                    this.$refs.abroadsTable.setCurrentRow(this.networkList.abroads.filter(item => {
                        return item.status
                    })[0]);
                    this.loading = false;
                })
            },
            handleCurrentChange(type, val) {
                this[type] = val;
            },
            /**
             * type:abroads或inlands
             * ip:修改的ip类型
             * */
            setConfig(type, ip, id, {value, cb}) {
                let newType = this.networkList[type].map(item => {
                    if (item.id === id) {
                        item[ip] = value
                    }
                    return item
                });
                this.setStateNetworkList({
                    [type]: newType
                });
                cb()
            },
            saveFunc() {
                let html =
                    '<table>' +
                    '<tr><td>国内：</td></tr>' +
                    '<tr><td>' +
                    `<p>res:${this.inlandRow.resDomain}（ip:${this.inlandRow.resIp}）</p>` +
                    `<p>http:${this.inlandRow.httpDomain}（ip:${this.inlandRow.httpIp}）</p>` +
                    `<p>sck:${this.inlandRow.sckDomain}（ip:${this.inlandRow.sckIp}）</p>` +
                    '</td></tr>' +
                    '<tr><td>国外：</td></tr>' +
                    '<tr><td>' +
                    `<p>res:${this.abroadRow.resDomain}（ip:${this.abroadRow.resIp}）</p>` +
                    `<p>http:${this.abroadRow.httpDomain}（ip:${this.abroadRow.httpIp}）</p>` +
                    `<p>sck:${this.abroadRow.sckDomain}（ip:${this.abroadRow.sckIp}）</p>` +
                    '</td></tr>' +
                    '</table>';

                this.$confirm(html, '是否切换到以下域名IP', {
                    dangerouslyUseHTMLString: true,
                }).then(() => {
                    this.switchNetwork({
                        abroad: {
                            id: this.abroadRow.id,
                            httpIp: this.abroadRow.httpIp,
                            resIp: this.abroadRow.resIp,
                            sckIp: this.abroadRow.sckIp
                        },
                        inland: {
                            id: this.inlandRow.id,
                            httpIp: this.inlandRow.httpIp,
                            resIp: this.inlandRow.resIp,
                            sckIp: this.inlandRow.sckIp
                        }
                    }).then(() => {
                        this.$message.success('保存成功');
                        this.show = true;
                    })
                }).catch(() => {
                });

            },
            pushFunc() {
                // 切换推送请求
                this.pushInfo({
                    channel: this.channel,
                    machineType: this.machineType
                }).then(() => {
                    this.show = false;
                    this.$message.success('推送成功')
                })
            }
        }
    }
</script>
<style lang="scss" scoped>

    .common-table {
        padding: 20px 20px 60px;
        margin: -20px -20px -40px;
        :global(.current-row td:first-of-type::after) {
            content: '';
            position: absolute;
            top: 50%;
            left: 10px;
            z-index: 1;
            width: 20px;
            height: 20px;
            background-color: $green;
            border-radius: 50%;
            transform: translateY(-50%);
        }
        :global(.el-input) {
            width: 180px;
        }
    }

    .footer {
        position: relative;
        z-index: 2;
        text-align: center;
        background: linear-gradient(rgba(255, 255, 255, 0), #fff);
        :global(.el-button) {
            width: 120px;
        }
    }
</style>